export default __webpack_public_path__ + "static/media/step_img_2.bcf779a8.png";